import React, { useEffect } from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import {
  reset as resetVerification,
  selectCode,
} from "redux/features/verification/verificationSlice"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"
import SmartIdForm from "components/Sign/SmartId/Form"
import Code from "components/ui/Code"
import { Container } from "components/Sign/elements"
import { smartIdCountryOptions } from "helpers/countries"
import { SMART_ID_SIGN_PERSONAL_CODE } from "config"
import { ClientSmartIdFormValues } from "types"

type Props = {
  onSubmit: (values: ClientSmartIdFormValues) => void
}

const SmartIdSignComponent = ({ onSubmit }: Props) => {
  const dispatch = useAppDispatch()

  const code = useAppSelector((state) => selectCode(state)) || undefined
  const countryOptions = smartIdCountryOptions()

  const handleSubmit = (values: ClientSmartIdFormValues) => {
    onSubmit(values)
  }

  const handleCancel = () => {
    dispatch(resetVerification())
    dispatch(resetPolling())
  }

  // NOTE: reset form and confirmation code
  useEffect(() => {
    handleCancel()
  }, [])

  return (
    <Container>
      {code ? (
        <Code code={code} onCancel={handleCancel} />
      ) : (
        <SmartIdForm
          initialValues={{
            country: countryOptions[0].value,
            personal_code: SMART_ID_SIGN_PERSONAL_CODE,
          }}
          onSubmit={handleSubmit}
        />
      )}
    </Container>
  )
}

export default SmartIdSignComponent
